"use client";

import { usePathname } from "next/navigation";
import { Market } from "./config/i18n-config";
import getMarketFromPathname from "./utils/getMarketFromPathname";

export const useMarket = (): Market => {
  const pathname = usePathname();

  return getMarketFromPathname(pathname);
};
